<div class="mb-4 flex flex-col lg:flex-row lg:items-end lg:justify-between">
  <div>
    @if (title) {
      <h1
        class="mt-5 mb-2 bg-linear-to-b from-gradient-start from-0% via-gradient-middle2 via-50% to-gradient-end to-100% bg-clip-text text-5xl leading-tight text-transparent lg:text-8xl"
      >
        {{ title | translate }}
      </h1>
    }

    <!-- Header Actions Slot -->
    <ng-content select="[headerActions]"></ng-content>

    @if (subtitle) {
      <p class="text-lg leading-10">
        {{ subtitle | translate }}
      </p>
    }
  </div>

  <!-- Header End Slot -->
  <ng-content select="[headerEnd]"></ng-content>
</div>

<!-- Responsive grid layout -->
<div class="mb-4">
  <div class="flex flex-col gap-4 lg:flex-row lg:items-center">
    <div class="flex w-full gap-4">
      <!-- Search Area -->
      <div class="relative w-full lg:w-2/5">
        <input
          class="input w-full py-2.5 pl-10 text-neutral-800 placeholder:text-neutral-500 focus:outline-none"
          #searchInput
          [placeholder]="searchPlaceholder() | translate"
          (input)="onSearch(searchInput.value)"
        />
        <img
          class="absolute top-1/2 left-3 h-5 w-5 -translate-y-1/2 text-neutral-500"
          src="assets/icons/search.svg"
          alt="Search"
        />
      </div>

      <!-- Filter Area -->
      <!--      <dhp-filter-->
      <!--        *ngIf="showFilter"-->
      <!--        [selectedMagazineIds]="selectedMagazineIds"-->
      <!--        (magazineSelected)="onMagazinesChange($event)"-->
      <!--        [showOnlyMagazines]="true"-->
      <!--      ></dhp-filter>-->

      <!-- Additional Filter Area Slot -->
      <ng-content select="[filterArea]"></ng-content>
    </div>
  </div>
</div>

<!-- Header Bottom Slot -->
<ng-content select="[headerBottom]"></ng-content>

<hr class="mb-4 border-gray-200" />
